// Consistent themed section header used across Feed, Prayer and Finances.
// Navy base gradient + a per-section accent glow and icon, matching the app brand.
export function SectionBanner({ title, subtitle, icon: Icon, accent = "#E0A73A", children }) {
  return (
    <div className="rounded-3xl overflow-hidden relative px-5 py-5 mb-5" style={{ background: "linear-gradient(135deg,#0d2340 0%,#0A1B33 100%)" }} data-testid="section-banner">
      <div className="absolute -top-12 -right-8 h-36 w-36 rounded-full pointer-events-none" style={{ background: `radial-gradient(circle, ${accent}59, transparent 70%)` }} />
      <div className="absolute -bottom-14 -left-10 h-32 w-32 rounded-full bg-white/5 pointer-events-none" />
      <div className="relative flex items-center gap-4">
        <div className="h-12 w-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: `${accent}26` }}>
          <Icon className="h-6 w-6" style={{ color: accent }} />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="font-heading font-extrabold text-3xl text-white leading-none">{title}</h1>
          <p className="text-sm text-white/70 mt-1">{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
}
